import React from 'react';
import {GlobeIcon} from "@heroicons/react/outline";
import Field from "../Field";
import {FormikHelpers} from "formik";

type Props = {
  formik: FormikHelpers<any>
  id: string
  name: string
  placeholder?: string
  required?: boolean
  forceHttps?: boolean
}

function UrlField({formik, id, name, placeholder, required, forceHttps}: Props) {

  const handleChangeTermsUrl = (event: React.FormEvent<HTMLInputElement>) => {
    let value = event.currentTarget.value
    //
    // if (value.length >= 8 && (!value.startsWith("http://") && !value.startsWith("https://"))) {
    //   value = forceHttps ? `https://${value}` : `http://${value}`;
    // }

    void formik.setFieldValue(name, value)
  }

  return (
    <Field
      type="text"
      icon={GlobeIcon}
      name={name}
      id={id}
      maxLength={255}
      pattern="https?://.+"
      title="URLs starting with http or https only"
      onChange={handleChangeTermsUrl}
      placeholder={placeholder}
      required={required}
    />
  );
}

UrlField.defaultProps = {
  forceHttps: true
}

export default UrlField;